module.exports = __webpack_public_path__ + "img/toul-tompong-branch.5fa05fac.jpg";